// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IChatParticipantDto } from './chat-participant-dto.g';
import { IChatMessageDto } from './chat-message-dto.g';

export const chatDto = {
    guid: 'guid',
    domain_Guid: 'domain_Guid',
    project_Guid: 'project_Guid',
    project_Name: 'project_Name',
    task_Guid: 'task_Guid',
    task_Subject: 'task_Subject',
    subject: 'subject',
    timeZoneId: 'timeZoneId',
    closed: 'closed',
    isParticipant: 'isParticipant',
    done: 'done',
    canWrite: 'canWrite',
    readOnlyReason: 'readOnlyReason',
    hasMore: 'hasMore',
    participantDtos: 'participantDtos',
    messageDtos: 'messageDtos',
} as const;

export type TChatDto = (typeof chatDto)[keyof typeof chatDto];

export const chatDtoConstraints = {
    subject: { required: true },
    body: { required: true },
} as const;

export type TChatDtoConstraints = typeof chatDtoConstraints;

export interface IChatDto {
    [chatDto.guid]: string | null;
    [chatDto.domain_Guid]: string | null;
    [chatDto.project_Guid]: string | null;
    [chatDto.project_Name]: string | null;
    [chatDto.task_Guid]: string | null;
    [chatDto.task_Subject]: string | null;
    [chatDto.subject]: string | null;
    [chatDto.timeZoneId]: string | null;
    [chatDto.closed]: boolean | null;
    [chatDto.isParticipant]: boolean | null;
    [chatDto.done]: boolean | null;
    [chatDto.canWrite]: boolean | null;
    [chatDto.readOnlyReason]: string | null;
    [chatDto.hasMore]: boolean | null;
    [chatDto.participantDtos]: IChatParticipantDto[] | null;
    [chatDto.messageDtos]: IChatMessageDto[] | null;
}

export class ChatDto
    implements IChatDto
{
    [chatDto.guid]: string | null = null;
    [chatDto.domain_Guid]: string | null = null;
    [chatDto.project_Guid]: string | null = null;
    [chatDto.project_Name]: string | null = null;
    [chatDto.task_Guid]: string | null = null;
    [chatDto.task_Subject]: string | null = null;
    [chatDto.subject]: string | null = null;
    [chatDto.timeZoneId]: string | null = null;
    [chatDto.closed]: boolean | null = null;
    [chatDto.isParticipant]: boolean | null = null;
    [chatDto.done]: boolean | null = null;
    [chatDto.canWrite]: boolean | null = null;
    [chatDto.readOnlyReason]: string | null = null;
    [chatDto.hasMore]: boolean | null = null;
    [chatDto.participantDtos]: IChatParticipantDto[] | null = null;
    [chatDto.messageDtos]: IChatMessageDto[] | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IChatData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[chatDto.guid] = modelData[chatData.guid];
    }

    static create(modelData?: any | null): IChatDto | null {
        return modelData ? new ChatDto(modelData) : null;
    }
}
